/**
 * 自提图标
 */
const PickUpIconTestRide = ({ width = 18, height = 18, color = 'currentColor', ...props }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <path
        d="M3.59375 9.75781V14.7822H9.81444"
        stroke={color}
        strokeWidth="1.09375"
        strokeLinecap="square"
      />
      <path
        d="M14.1426 2.75L14.2646 3.13086L14.8262 4.89551L14.834 4.92285L14.8535 4.99512L14.8574 5.01074C14.9041 5.21228 14.9174 5.41926 14.8975 5.62402L14.8662 5.82715C14.824 6.02956 14.749 6.22306 14.6455 6.40137L14.5332 6.57422C14.3704 6.79723 14.1625 6.98468 13.9238 7.12598C13.7448 7.23193 13.5506 7.3105 13.3486 7.36035L13.1445 7.40039C12.9379 7.43074 12.7277 7.43167 12.5215 7.40234L12.3174 7.36328C12.1145 7.31423 11.9202 7.23567 11.7412 7.13086L11.5674 7.01758C11.3995 6.89533 11.2514 6.7489 11.1289 6.58301L11.0156 6.41016C10.8759 6.17232 10.7881 5.9086 10.7598 5.63477H10.6865V5.63867L10.6855 5.64648L10.6768 5.71875L10.6748 5.73242C10.6004 6.2236 10.3369 6.6646 9.94629 6.97461C9.60524 7.2452 9.18614 7.40187 8.75195 7.42871L8.56543 7.43164C8.12806 7.42115 7.70303 7.27992 7.35352 7.02441L7.20898 6.90723C6.83595 6.57895 6.59743 6.1275 6.54883 5.63477H6.47559V5.6377L6.47461 5.64551L6.46484 5.71875L6.46387 5.72656L6.46289 5.7334C6.39552 6.17689 6.17474 6.57833 5.8457 6.87988L5.69824 7.00293C5.33999 7.27418 4.90177 7.422 4.45312 7.43164L4.26074 7.42773C3.74604 7.39315 3.25753 7.176 2.89648 6.81152C2.53447 6.44606 2.32734 5.95838 2.32812 5.44531V5.42578L2.33203 5.3252L2.33301 5.30664L2.33496 5.28711L2.3457 5.18848L2.34668 5.17773L2.34863 5.16797L2.37402 5.03125C2.38407 4.98606 2.39487 4.94087 2.4082 4.89648L2.41211 4.88477L2.98438 3.12793L3.10742 2.75H14.1426Z"
        stroke={color}
        strokeWidth="1.09375"
      />
      <path
        d="M10.8242 9.55469H14.5156L15.7461 11.4004V15.707H9.59375V11.4004L10.8242 9.55469Z"
        stroke={color}
        strokeWidth="1.09375"
        strokeLinecap="square"
        strokeLinejoin="bevel"
      />
      <path d="M9.59375 11.3984H15.7461" stroke={color} strokeWidth="1.09375" />
    </svg>
  )
}

export default PickUpIconTestRide
